import "./fontawesome";
import "./owl.carousel";
import "./main.scss";
import "bootstrap/js/dist/tab";
import $ from 'jquery'

import { Script } from "vm";

// Header Osvaldas Valutis
(function(document, window, index) {
  "use strict";

  var elSelector = ".header";
  var element = document.querySelector(elSelector);

  if (!element) return true;

  var elHeight = 0;
  var elTop = 0;
  var dHeight = 0;
  var wHeight = 0;
  var wScrollCurrent = 0;
  var wScrollBefore = 0;
  var wScrollDiff = 0;

  window.addEventListener("scroll", function() {
    elHeight = element.offsetHeight;
    dHeight = document.body.offsetHeight;
    wHeight = window.innerHeight;
    wScrollCurrent = window.pageYOffset;
    wScrollDiff = wScrollBefore - wScrollCurrent;
    elTop =
      parseInt(window.getComputedStyle(element).getPropertyValue("top")) +
      wScrollDiff;

    if (wScrollCurrent <= 0) {
      // scrolled to the very top; element sticks to the top
      element.style.top = "0px";
    } else if (wScrollDiff > 0) {
      // scrolled up; element slides in
      element.style.top = (elTop > 0 ? 0 : elTop) + "px";
    } else if (wScrollDiff < 0) {
      // scrolled down
      if (wScrollCurrent + wHeight >= dHeight - elHeight) {
        // scrolled to the very bottom; element slides in
        element.style.top =
          ((elTop = wScrollCurrent + wHeight - dHeight) < 0 ? elTop : 0) + "px";
      } else {
        // scrolled down; element slides out
        element.style.top =
          (Math.abs(elTop) > elHeight ? -elHeight : elTop) + "px";
      }
    }

    wScrollBefore = wScrollCurrent;
  });
})(document, window, 0);

//Selects zones on imageMapper on click on categories
$(function() {
  
  $('.category__hover').on('click', function(event) {
    event.preventDefault;
    var categoryId = $(this).attr('data-categoryId');
    $('.path-area').find('.category__zone').removeClass('active');
    $('.path-area').find('.category__' + categoryId).addClass('active');
  });

  $('.category__hover').on('mouseenter', function() {
    var categoryId = $(this).attr('data-categoryId');
    $('.path-area').find('.category__' + categoryId).addClass('active');
  });
  $('.category__hover').on('mouseleave', function() {
    $('.path-area').find('.category__zone').removeClass('active');
  });
});